import { Fragment } from "react";
import { useSelector } from "react-redux";
import {
  FilteringForm,
  initialFilteringValues,
  filteringValidationSchema,
} from "./FilteringForm";
import { PageHeader } from "../../../components/PageHeader";
import { Formik } from "formik";
import Button from "@material-ui/core/Button";
import AddCircleOutlinedIcon from "@material-ui/icons/AddCircleOutlined";

export const ListingPageHeader = (props) => {
  const { setCreating, handleFilterChange, clearNotification } = props;

  return (
    <PageHeader title="死亡記錄">
      <Formik
        initialValues={initialFilteringValues}
        validationSchema={filteringValidationSchema}
      >
        {() => (
          <Fragment>
            <FilteringForm handleFilterChange={handleFilterChange} />
            <Button
              style={{ marginRight: 15 }}
              variant="contained"
              color="primary"
              startIcon={<AddCircleOutlinedIcon />}
              onClick={() => {
                clearNotification();
                setCreating(true);
              }}
            >
              新增死亡紀錄
            </Button>
          </Fragment>
        )}
      </Formik>
    </PageHeader>
  );
};
